<template>
  <div
    class="logo"
    :style="{ background: bg, width, height: width, lineHeight: width, fontSize: size }"
  >
    {{ getLogoNameFn() }}
    <div
      v-if="props.isShow"
      class="setLogo"
      @click="updataFn"
    >
      切换
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch } from 'vue';
import { useAppStore } from '../../store/modules/app.ts';

const appStore = useAppStore();
const props = defineProps({
  name: {
    type: String,
    default: '',
  },
  isNumber: {
    // 展示数量
    type: Number,
    default: 2,
  },
  size: {
    // 字号
    type: String,
    default: '12px',
  },
  isKey: {
    type: String,
    default: '111',
  },
  keyType: {
    // 模块   怕数组太大定义不同模块
    type: String,
    default: 'logo',
  },
  // 头像设置
  width: {
    type: String,
    default: '35px',
  },
  // 是否缓存   默认缓存
  isLocal: {
    type: Boolean,
    default: true,
  },
  // 是否缓存   默认缓存
  isShow: {
    type: Boolean,
    default: false,
  },
});
const bg = ref('#11bc5d');
onMounted(() => {
  setLogo();
});
watch(
  () => appStore.appLogoNum,
  () => {
    setLogo();
  },
);
// 设置头像
const setLogo = () => {
  const logoObj = localStorage.getItem('AvatarColorLoso') ? JSON.parse(localStorage.getItem('AvatarColorLoso')) : {};
  if (logoObj && logoObj[props.keyType]) {
    const arr = logoObj[props.keyType].filter((v) => {
      return v.key == props.isKey;
    });
    if (arr.length > 0) {
      bg.value = arr[0].bg;
    } else {
      const color = generateAvatarColor();
      bg.value = color;
      logoObj[props.keyType].push({ key: props.isKey, name: props.name, bg: color });
      localStorage.setItem('AvatarColorLoso', JSON.stringify(logoObj));
    }

    // 可能存在
  } else {
    // 不存在
    console.log('不存在');
    const color = generateAvatarColor();
    bg.value = color;
    logoObj[props.keyType] = [{ key: props.isKey, name: props.name, bg: color }];
    localStorage.setItem('AvatarColorLoso', JSON.stringify(logoObj));
  }
};
// 更新头像
function updataFn() {
  const logoObj = localStorage.getItem('AvatarColorLoso') ? JSON.parse(localStorage.getItem('AvatarColorLoso')) : {};
  const arr = logoObj[props.keyType].filter((v) => {
    return v.key != props.isKey;
  });
  const color = generateAvatarColor();
  bg.value = color;
  arr.push({ key: props.isKey, name: props.name, bg: color });
  logoObj[props.keyType] = arr;
  localStorage.setItem('AvatarColorLoso', JSON.stringify(logoObj));
  appStore.setAppLogoNum();

  console.log('arr', arr);
}

// 生成随机颜色（避开白色、灰色，适配白色字体，推荐）
function generateAvatarColor() {
  // 色相h：0-360（全色系随机，保证颜色丰富）
  const h = Math.floor(Math.random() * 360);
  // 饱和度s：70%-100%（高饱和度，彻底避开灰色系）
  const s = Math.floor(Math.random() * 30) + 70;
  // 亮度l：20%-60%（避开高亮度接近白色，低亮度避免过暗）
  const l = Math.floor(Math.random() * 40) + 20;

  // 直接返回HSL格式颜色，浏览器可直接识别
  return `hsl(${h}, ${s}%, ${l}%)`;
}
// 头像设置
/**
 * 处理字符串，返回指定规则的结果
 * @param {string} str - 待处理的原始字符串
 * @returns {string|null} - 处理后的结果（符合规则的字符串或null）
 */
function getLogoNameFn() {
  const str = props.name;
  // 1. 判断是否为空（null、undefined、空字符串""都视为"空"）
  if (str === null || str === undefined || str === '') {
    return 'null';
  }

  // 2. 确保传入的是字符串类型（避免非字符串参数导致length报错）
  const targetStr = String(str);

  // 3. 根据字符串长度返回对应结果
  if (targetStr.length > props.isNumber) {
    // 长度大于2，返回最后两位（slice(-2) 是获取字符串最后两位的便捷方法）
    return targetStr.slice(-props.isNumber);
  } else {
    // 长度小于等于2，返回字符串本身
    return targetStr;
  }
}
</script>
<style lang="scss">
.logo {
  display: inline-block;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  overflow: hidden;
  position: relative;
  &:hover {
    .setLogo {
      display: block !important;
    }
  }

  .setLogo {
    position: absolute;
    bottom: 0;
    background: rgba($color: #2f2e2e, $alpha: 0.5); /* 灰色 + 0.5 透明度 */
    cursor: pointer;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    width: 100%;
    text-align: center;
    z-index: 999999;
    display: none;
    color: #eee;
  }
}
</style>
